import React, { useEffect, useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { auth } from "../Firebase/utils";

import { useAppDispatch, useAppSelector } from "../store/store";
import { deleteSurveyQuestion } from "../Firebase/utils";
import { deleteQuestion } from "../store/features/CreateSurveySlice";
import { Question, Survey } from "../types";


const useDeleteSurveyQuestion = (survey: Survey, question: Question) => {

  const [ error, setError ] = useState<string | null>(null);
  const [ loading, setLoading ] = useState<boolean>(false);

  const dispatch = useAppDispatch();


  const mutation = useMutation({
    mutationFn: async () => {
      await deleteSurveyQuestion(survey, question);
    },
    onSuccess: () => {
      dispatch(deleteQuestion(question));
    },
    onError: (error) => {
      console.error(error);
      setError("An error occurred while deleting the question.");
    }
  });

  useEffect(() => {
    if (mutation.isPending) {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [mutation.isPending]);

  return {
    deleteQuestion: mutation.mutate,
    loading,
    error,
  };


};

export default useDeleteSurveyQuestion;